export const replaceHTML = (string) => string?.replace(/<[^>]*>?/gm, '');
